import * as AuthActionType from '../actionType/auth.actionType';

const initialState = {
    loginErr: '',
    loginSuccess: '',
    voucherErr: '',
    voucherSuccess: '',
    forgetSuccess: '',
    forgetError: '',
    token: '',
    captchaError: '',
    captchaVal: '0 + 0',
    captchaResult: '',
    setError: false,
    validationMsg: '',
    message: ''
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AuthActionType.LOGIN_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.LOGIN_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_LOGIN_ERR:
            return {...state, loginErr: '', voucherErr: '', voucherSuccess: ''};
        case AuthActionType.VOUCHER_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.VOUCHER_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_CAPTCHA:
            return {...state, ...action.payload};
        case AuthActionType.FORGOT_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.FORGOT_SUCCESS:
            return {...state, ...action.payload};
        case AuthActionType.RESET_FORGET_MSG:
            return {...state, forgetError: '', forgetSuccess: ''};
        case AuthActionType.CAPTCHA_ERROR:
            return {...state, ...action.payload};
        case AuthActionType.GET_VALUE:
            return {...state, ...action.payload};
        case AuthActionType.CAPTCHA_VALIDATION:
            return {...state, ...action.payload};
        default:
            return state;
    }
};
